import {Component, Input, OnInit, Renderer2} from '@angular/core';
import {DrawerModes, ListingCategory, SearchType} from '../../classes/enums';
import {animate, style, transition, trigger} from '@angular/animations';
import {ActivatedRoute, Router} from '@angular/router';
import {CommunicationService} from '../../services/communication.service';
import {HasSubscriptions} from '../has-subscriptions';
import {StyleService} from '../../services/style/style.service';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
  animations: [
    trigger('drawerTrigger', [
      transition(':enter', [
        style({height: '0'}),
        animate('500ms ease-out', style({height: '100vh'}))
      ]),
      transition(':leave', [
        style({height: '*'}),
        animate('500ms ease-in', style({height: '0'}))
      ])
    ])
  ]
})

export class DrawerComponent extends HasSubscriptions implements OnInit {
  @Input() currentShownListingType: ListingCategory;
  searchType: SearchType = SearchType.OFFICE;
  constructor(private _renderer: Renderer2,
              private _router: Router,
              private activatedRoute: ActivatedRoute,
              private communicationService: CommunicationService,
              private styleService: StyleService) {
    super();
  }

  drawerMode: DrawerModes = DrawerModes.CLOSED;

  ngOnInit(): void {
  }

  openDrawer(mode: DrawerModes) {
    // we need to pass the searchType to the filters component, this is where we get the value from the activatedRoute
    // not sure why the firstChild is required, but I wasn't able to get the values without it
    if (this.activatedRoute.snapshot.firstChild && this.activatedRoute.snapshot.firstChild.params.type) {
      this.searchType = this.activatedRoute.snapshot.firstChild.params.type.toUpperCase() as SearchType;
    }
    this.drawerMode = mode;
    this.styleService.addClass(this._renderer, 'html', 'no-scroll');
  }

  closeDrawer(navigateHome: boolean = false) {
    this.drawerMode = DrawerModes.CLOSED;
    // TODO: is this the right way to do it
    this.styleService.removeClass(this._renderer, 'html', 'no-scroll');
    this.communicationService.navigation.showSearch.next(false);
    if (navigateHome && !(this._router.url.includes('-lst') || this._router.url.includes('-prty'))) {
      this._router.navigate(['/find-real-estate']);
    }
  }

  // enums:
  DrawerModes = DrawerModes;
  ListingCategory = ListingCategory;
}
